/**
 * Display normaliser for server headlines that mix `5:00 pm` with `7:30 PM`.
 *
 * WEB-1189 C11. The API still emits lowercase meridiem; this is a web-only
 * display seam. A 24-hour string (no am/pm token) is left unchanged (FRE-1192).
 */

const MERIDIEM_PATTERN = /\b(\d{1,2}(?::\d{2})?)\s*([ap])\.?m\.?(?![A-Za-z])/gi;

/**
 * Rewrite `5:00 pm`, `5 pm`, and `5 p.m.` to `5:00 PM` / `5 PM`.
 * Pure. Strings with no meridiem token round-trip unchanged.
 */
export function normalizeMeridiem(value: string): string {
  return value.replace(MERIDIEM_PATTERN, (_match: string, time: string, ap: string) => {
    return `${time} ${ap.toUpperCase()}M`;
  });
}
